import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
} from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import RecommendIcon from "@mui/icons-material/Recommend";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const ProInvite = () => {
  const [proEmail, setProEmail] = React.useState("");
  const [proFirstName, setProFirstName] = React.useState("");
  const [proLastName, setProLastName] = React.useState("");
  const [patientEmail, setPatientEmail] = React.useState("");
  // RecommendationDTO : patientId, recommendingProfessionalId (optionnel
  // pour un admin), recommendedProfessionalId.
  const [recoPatientId, setRecoPatientId] = React.useState("");
  const [recommendingProId, setRecommendingProId] = React.useState("");
  const [recommendedProId, setRecommendedProId] = React.useState("");
  const notify = useNotify();

  const invitePro = async () => {
    if (!proEmail.trim()) return;
    try {
      await httpClient(`${API_BASE_URL}/pro/invite`, {
        method: "POST",
        // ProfessionalInviteDTO { firstName, lastName, email, phone?, invitingProId? }
        body: JSON.stringify({
          email: proEmail,
          firstName: proFirstName || null,
          lastName: proLastName || null,
        }),
      });
      notify("Invitation pro envoyée", { type: "success" });
      setProEmail(""); setProFirstName(""); setProLastName("");
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  const invitePatient = async () => {
    if (!patientEmail.trim()) return;
    try {
      await httpClient(`${API_BASE_URL}/pro/invite-patient`, {
        method: "POST",
        body: JSON.stringify({ email: patientEmail }),
      });
      notify("Invitation patient envoyée", { type: "success" });
      setPatientEmail("");
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  const recoBody = () =>
    JSON.stringify({
      patientId: recoPatientId.trim(),
      recommendingProfessionalId: recommendingProId.trim() || null,
      recommendedProfessionalId: recommendedProId.trim(),
    });
  const recoReady = recoPatientId.trim() && recommendedProId.trim();

  // /pro/recommend : recommande le patient au pro recommandé (email au pro)
  const recommend = async () => {
    if (!recoReady) return;
    try {
      await httpClient(`${API_BASE_URL}/pro/recommend`, {
        method: "POST",
        body: recoBody(),
      });
      notify("Recommandation envoyée", { type: "success" });
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  // /pro/recommend/praticien : recommande le pro au patient (notif + chat)
  const recommendPraticien = async () => {
    if (!recoReady) return;
    try {
      await httpClient(`${API_BASE_URL}/pro/recommend/praticien`, {
        method: "POST",
        body: recoBody(),
      });
      notify("Praticien recommandé", { type: "success" });
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <GroupAddIcon /> Invitations & recommandations
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Inviter un nouveau pro/patient ou recommander une mise en relation entre un patient et un pro.
      </Alert>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            <GroupAddIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />
            Inviter un nouveau professionnel
          </Typography>
          <Stack direction="row" spacing={1}>
            <TextField size="small" type="email" label="Email" value={proEmail}
              onChange={(e) => setProEmail(e.target.value)} />
            <TextField size="small" label="Prénom (optionnel)" value={proFirstName}
              onChange={(e) => setProFirstName(e.target.value)} />
            <TextField size="small" label="Nom (optionnel)" value={proLastName}
              onChange={(e) => setProLastName(e.target.value)} />
            <Button variant="contained" onClick={invitePro} disabled={!proEmail.trim()}>
              Envoyer
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            <PersonAddIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />
            Inviter un patient
          </Typography>
          <Stack direction="row" spacing={1}>
            <TextField size="small" type="email" label="Email" value={patientEmail}
              onChange={(e) => setPatientEmail(e.target.value)} />
            <Button variant="contained" onClick={invitePatient} disabled={!patientEmail.trim()}>
              Envoyer
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            <RecommendIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />
            Recommandation
          </Typography>
          <Stack spacing={1}>
            <Stack direction="row" spacing={1}>
              <TextField size="small" label="ID patient" value={recoPatientId}
                onChange={(e) => setRecoPatientId(e.target.value)} />
              <TextField size="small" label="ID pro recommandant (optionnel)" value={recommendingProId}
                onChange={(e) => setRecommendingProId(e.target.value)} />
              <TextField size="small" label="ID pro recommandé" value={recommendedProId}
                onChange={(e) => setRecommendedProId(e.target.value)} />
            </Stack>
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={recommend} disabled={!recoReady}>
                Recommander le patient au pro
              </Button>
              <Button variant="outlined" onClick={recommendPraticien} disabled={!recoReady}>
                Recommander le pro au patient
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: ProInvite };
